export const listTitles = [
  { id: 0, text: 'Tester name' },
  { id: 1, text: 'Email' },
  { id: 2, text: 'Date Submitted' },
  { id: 3, text: 'Status' },
];

/*
  STATUS descriptions:
    - not_submitted -> the tester didn’t submit the study
    - submitted -> waiting for review: the tester submitted a practice test video
    - approved -> tester is approved and can test
*/
export const STATUS = {
  NOT_SUBMITTED: 'not_submitted',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  BLOCKED: 'blocked',
};

export const STATUS_TEXT = {
  NOT_SUBMITTED: 'Not submitted',
  SUBMITTED: 'Submitted - waiting for review',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  BLOCKED: 'Blocked',
};

export const STATUS_OPTIONS = [
  {
    key: 0, value: STATUS.SUBMITTED, text: STATUS_TEXT.SUBMITTED, checked: false,
  },
  {
    key: 1, value: STATUS.NOT_SUBMITTED, text: STATUS_TEXT.NOT_SUBMITTED, checked: false,
  },
  {
    key: 2, value: STATUS.APPROVED, text: STATUS_TEXT.APPROVED, checked: false,
  },
  {
    key: 3, value: STATUS.REJECTED, text: STATUS_TEXT.REJECTED, checked: false,
  },
  {
    key: 4, value: STATUS.BLOCKED, text: STATUS_TEXT.BLOCKED, checked: false,
  },
];

export const dropdownItems = [
  { key: 1, text: 'Submitted - waiting for review', value: 'submitted' },
  { key: 2, text: 'Not submitted', value: 'not_submitted' },
  { key: 3, text: 'Approved', value: 'approved' },
  { key: 4, text: 'Rejected', value: 'rejected' },
  { key: 5, text: 'Blocked', value: 'blocked' },
  { key: 6, text: 'All', value: 'All' },
];

export const TITLE = 'Practice Tests';

export const DEBOUNCE_TIME = 700;
